(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8864],{

/***/ 38285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ BannerCode; }
/* harmony export */ });
var BannerCode;
(function(BannerCode) {
    BannerCode["Izanavi"] = "IZANAVI";
    BannerCode[// Platinum = 'Platinum',
    "Anime"] = "Anime";
    BannerCode["DiscountPrimeSub"] = "DiscountPrimeSub";
    BannerCode["DiscountMembership"] = "DiscountMembership";
    BannerCode["TakatradeOpening"] = "TakatradeOpening";
    BannerCode["Event"] = "Event";
})(BannerCode || (BannerCode = {}));


/***/ }),

/***/ 85222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8405);
/* harmony import */ var _AnimeAlarmBanner_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80850);
/* harmony import */ var _AnimeAlarmBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_AnimeAlarmBanner_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12800);
/* harmony import */ var common_utils_anime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1875);
/* harmony import */ var common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67027);
/* harmony import */ var _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38367);










var randomColor = function() {
    var random = Math.floor(Math.random() * 3);
    if (random === 1) return "blue";
    if (random === 2) return "purple";
    return "";
};
var AnimeAlarmBanner = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(randomColor()), currentColor = ref[0];
    var showAnimeOnboardingDialog = (0,store_global__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(state) {
        return state.showAnimeOnboardingDialog;
    });
    var setUserClickedAnimeIcon = (0,store_global__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(state) {
        return state.setUserClickedAnimeIcon;
    });
    var currentUser = (0,store_timeline__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(function(state) {
        return state.currentUser;
    });
    if (!currentUser) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()((_AnimeAlarmBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().animeAlarmsBanner), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_AnimeAlarmBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[currentColor], !!currentColor)),
        onClick: function() {
            (0,_amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_9__/* .track */ .j)("Click Top Banner", {
                banner_type: "ai_banner"
            });
            if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.anime_character_onboarding) || !(currentUser === null || currentUser === void 0 ? void 0 : currentUser.user_character)) {
                showAnimeOnboardingDialog(true);
            }
            if (currentUser === null || currentUser === void 0 ? void 0 : currentUser.user_character) {
                setUserClickedAnimeIcon(true);
            }
            (0,common_utils_anime__WEBPACK_IMPORTED_MODULE_5__/* .addAnimeTrackingEvent */ .Bx)({
                action: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_6__/* .EventAction.Click */ .AO.Click,
                component: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_6__/* .EventComponent.AnimeFunctionBanner */ .Br.AnimeFunctionBanner,
                position: "banner"
            });
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_AnimeAlarmBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_AnimeAlarmBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().text),
                        children: "AIキャラクターに新要素が追加！"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_AnimeAlarmBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().smallText),
                        children: "無料機能も拡大！"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_AnimeAlarmBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().lastImage),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/images/banners/anime_banner/anime-banner-characters-1.png",
                    className: (_AnimeAlarmBanner_module_scss__WEBPACK_IMPORTED_MODULE_7___default().image)
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnimeAlarmBanner);


/***/ }),

/***/ 68864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_RandomBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./service/user.ts
var user = __webpack_require__(8193);
// EXTERNAL MODULE: ./store/timeline.ts
var timeline = __webpack_require__(12800);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/atoms/IGBanner/IGBanner.module.scss
var IGBanner_module = __webpack_require__(37438);
var IGBanner_module_default = /*#__PURE__*/__webpack_require__.n(IGBanner_module);
// EXTERNAL MODULE: ./node_modules/@amplitude/analytics-browser/lib/esm/index.js + 164 modules
var esm = __webpack_require__(38367);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/atoms/IGBanner/index.tsx







var randomBgUrl = function(coinNumber) {
    if (coinNumber === 20000) {
        return "/images/banners/ig-2man-coin-202507.jpg";
    } else {
        var random = Math.floor(Math.random() * 3);
        if (random === 1) return "/images/banners/ig_banner_1_pr.jpg";
        if (random === 2) return "/images/banners/ig_banner_2_pr.jpg";
        return "/images/banners/ig_banner_3_pr.jpg";
    }
};
var IGBanner = function(param) {
    var fallbackElement = param.fallbackElement, className = param.className;
    var ref;
    var allMissions = (0,timeline/* default */.ZP)(function(state) {
        return state.allMissions;
    });
    var igMission = (0,react.useMemo)(function() {
        return allMissions.find(function(mission) {
            return mission.code === user/* MissionCode.IGCreateAccount */.Vk.IGCreateAccount;
        });
    }, [
        allMissions
    ]);
    var showingBanner = igMission && [
        user/* MissionTaskStatus.NotYet */.RP.NotYet,
        user/* MissionTaskStatus.InProgress */.RP.InProgress
    ].includes(igMission === null || igMission === void 0 ? void 0 : (ref = igMission.current_task) === null || ref === void 0 ? void 0 : ref.status);
    var bgUrl = (0,react.useMemo)(function() {
        return randomBgUrl(igMission === null || igMission === void 0 ? void 0 : igMission.coin);
    }, [
        igMission === null || igMission === void 0 ? void 0 : igMission.coin
    ]);
    if (!showingBanner || !bgUrl) return fallbackElement ? fallbackElement : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((IGBanner_module_default()).banner, className !== null && className !== void 0 ? className : ""),
        onClick: function() {
            var ref;
            (0,esm/* track */.j)("Click Top Banner", {
                banner_type: "ig_banner"
            });
            (ref = window.open(igMission === null || igMission === void 0 ? void 0 : igMission.link, "_blank")) === null || ref === void 0 ? void 0 : ref.focus();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: bgUrl,
            width: "100%"
        })
    });
};
/* harmony default export */ var atoms_IGBanner = (IGBanner);

// EXTERNAL MODULE: ./components/atoms/InvastBanner/InvastBanner.module.scss
var InvastBanner_module = __webpack_require__(60197);
var InvastBanner_module_default = /*#__PURE__*/__webpack_require__.n(InvastBanner_module);
;// CONCATENATED MODULE: ./components/atoms/InvastBanner/index.tsx







var InvastBanner_randomBgUrl = function() {
    return "/images/banners/invast_banner_pr.jpg";
};
var InvastBanner = function(param) {
    var fallbackElement = param.fallbackElement, className = param.className;
    var ref;
    var allMissions = (0,timeline/* default */.ZP)(function(state) {
        return state.allMissions;
    });
    var invastMission = (0,react.useMemo)(function() {
        return allMissions.find(function(mission) {
            return mission.code === user/* MissionCode.InvastCreateAccount */.Vk.InvastCreateAccount;
        });
    }, [
        allMissions
    ]);
    var showingBanner = invastMission && [
        user/* MissionTaskStatus.NotYet */.RP.NotYet,
        user/* MissionTaskStatus.InProgress */.RP.InProgress
    ].includes(invastMission === null || invastMission === void 0 ? void 0 : (ref = invastMission.current_task) === null || ref === void 0 ? void 0 : ref.status);
    var bgUrl = (0,react.useMemo)(function() {
        return InvastBanner_randomBgUrl();
    }, []);
    if (!showingBanner || !bgUrl) return fallbackElement ? fallbackElement : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((InvastBanner_module_default()).banner, className !== null && className !== void 0 ? className : ""),
        onClick: function() {
            var ref;
            (0,esm/* track */.j)("Click Top Banner", {
                banner_type: "invast_banner"
            });
            (ref = window.open(invastMission === null || invastMission === void 0 ? void 0 : invastMission.link, "_blank")) === null || ref === void 0 ? void 0 : ref.focus();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: bgUrl,
            width: "100%"
        })
    });
};
/* harmony default export */ var atoms_InvastBanner = (InvastBanner);

// EXTERNAL MODULE: ./common/utils/banner.ts
var banner = __webpack_require__(38285);
// EXTERNAL MODULE: ./common/utils/membership.ts
var membership = __webpack_require__(77063);
// EXTERNAL MODULE: ./components/molecules/IzanaviBanner/IzanaviBanner.module.scss
var IzanaviBanner_module = __webpack_require__(56841);
var IzanaviBanner_module_default = /*#__PURE__*/__webpack_require__.n(IzanaviBanner_module);
// EXTERNAL MODULE: ./store/global.ts
var global = __webpack_require__(8405);
;// CONCATENATED MODULE: ./components/molecules/IzanaviBanner/index.tsx





var IzanaviBanner = function(param) {
    var className = param.className;
    var showIzanaviPRDialog = (0,global/* default */.Z)(function(state) {
        return state.showIzanaviPRDialog;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((IzanaviBanner_module_default()).banner, className !== null && className !== void 0 ? className : ""),
        onClick: function() {
            (0,esm/* track */.j)("Click Top Banner", {
                banner_type: "izanavi_banner"
            });
            showIzanaviPRDialog(true);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: "/images/izanavi/izanavi-yoko-banner-2025.jpg",
            width: "100%"
        })
    });
};
/* harmony default export */ var molecules_IzanaviBanner = (IzanaviBanner);

// EXTERNAL MODULE: ./components/common/AnimeAlarmBanner/index.tsx
var AnimeAlarmBanner = __webpack_require__(85222);
// EXTERNAL MODULE: ./components/atoms/MooMooBanner/MooMooBanner.module.scss
var MooMooBanner_module = __webpack_require__(62187);
var MooMooBanner_module_default = /*#__PURE__*/__webpack_require__.n(MooMooBanner_module);
;// CONCATENATED MODULE: ./components/atoms/MooMooBanner/index.tsx







var MooMooBanner_randomBgUrl = function(coinNumber) {
    if (coinNumber === 10000) {
        return "/images/banners/moomoo-banner-4-25.jpg";
    } else {
        return "/images/banners/moomoo-banner.jpg";
    }
};
var MooMooBanner = function(param) {
    var fallbackElement = param.fallbackElement, className = param.className;
    var ref;
    var allMissions = (0,timeline/* default */.ZP)(function(state) {
        return state.allMissions;
    });
    var moomooMission = (0,react.useMemo)(function() {
        return allMissions.find(function(mission) {
            return mission.code === user/* MissionCode.MooMooCreateAccount */.Vk.MooMooCreateAccount;
        });
    }, [
        allMissions
    ]);
    var showingBanner = moomooMission && [
        user/* MissionTaskStatus.NotYet */.RP.NotYet,
        user/* MissionTaskStatus.InProgress */.RP.InProgress
    ].includes(moomooMission === null || moomooMission === void 0 ? void 0 : (ref = moomooMission.current_task) === null || ref === void 0 ? void 0 : ref.status);
    var bgUrl = (0,react.useMemo)(function() {
        return MooMooBanner_randomBgUrl(moomooMission === null || moomooMission === void 0 ? void 0 : moomooMission.coin);
    }, [
        moomooMission === null || moomooMission === void 0 ? void 0 : moomooMission.coin
    ]);
    if (!showingBanner || !bgUrl) return fallbackElement ? fallbackElement : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((MooMooBanner_module_default()).banner, className !== null && className !== void 0 ? className : ""),
        onClick: function() {
            var ref;
            (0,esm/* track */.j)("Click Top Banner", {
                banner_type: "moomoo_banner"
            });
            (ref = window.open(moomooMission === null || moomooMission === void 0 ? void 0 : moomooMission.link, "_blank")) === null || ref === void 0 ? void 0 : ref.focus();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: bgUrl,
            width: "100%"
        })
    });
};
/* harmony default export */ var atoms_MooMooBanner = (MooMooBanner);

// EXTERNAL MODULE: ./components/modules/PrimeSubscriptionDiscountCampaign/DiscountCampaignBanner/DiscountCampaignBanner.module.scss
var DiscountCampaignBanner_module = __webpack_require__(56972);
var DiscountCampaignBanner_module_default = /*#__PURE__*/__webpack_require__.n(DiscountCampaignBanner_module);
// EXTERNAL MODULE: ./common/utils/index.ts + 1 modules
var utils = __webpack_require__(22467);
// EXTERNAL MODULE: ./common/utils/user.ts
var utils_user = __webpack_require__(97542);
;// CONCATENATED MODULE: ./components/modules/PrimeSubscriptionDiscountCampaign/DiscountCampaignBanner/index.tsx









var DiscountCampaignBanner_randomBgUrl = function() {
    var random = Math.floor(Math.random() * 2);
    if (random === 1) return "/images/banners/discount-prime-50percent-2025-01.jpg";
    return "/images/banners/discount-prime-50percent-2025-02.jpg";
};
var DiscountCampaignBanner = function(param) {
    var fallbackElement = param.fallbackElement, className = param.className;
    var bgUrl = (0,react.useMemo)(function() {
        return DiscountCampaignBanner_randomBgUrl();
    }, []);
    var showDiscountCreatorsDialog = (0,global/* default */.Z)(function(state) {
        return state.showDiscountCreatorsDialog;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var discountPrimeSubEvent = (0,utils_user/* getPrimeDiscountEvent */.Fo)(currentUser);
    if (!discountPrimeSubEvent || !bgUrl) return fallbackElement ? fallbackElement : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((DiscountCampaignBanner_module_default()).banner, className !== null && className !== void 0 ? className : ""),
        onClick: function() {
            (0,esm/* track */.j)("Click Top Banner", {
                banner_type: utils/* PRIME_DISCOUNT_202505 */.zA
            });
            showDiscountCreatorsDialog(true);
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: bgUrl,
            width: "100%"
        })
    });
};
/* harmony default export */ var PrimeSubscriptionDiscountCampaign_DiscountCampaignBanner = (DiscountCampaignBanner);

// EXTERNAL MODULE: ./components/atoms/MonexBanner/MonexBanner.module.scss
var MonexBanner_module = __webpack_require__(59560);
var MonexBanner_module_default = /*#__PURE__*/__webpack_require__.n(MonexBanner_module);
;// CONCATENATED MODULE: ./components/atoms/MonexBanner/index.tsx







var MonexBanner_randomBgUrl = function(coinNumber) {
    if (coinNumber === 20000) {
        return "/images/banners/monex-20000-0701.jpg";
    } else {
        return "/images/banners/monex-10000-0701.jpg";
    }
};
var MonexBanner = function(param) {
    var fallbackElement = param.fallbackElement, className = param.className;
    var ref;
    var allMissions = (0,timeline/* default */.ZP)(function(state) {
        return state.allMissions;
    });
    var monexMission = (0,react.useMemo)(function() {
        return allMissions.find(function(mission) {
            return mission.code === user/* MissionCode.MonexCreateAccount */.Vk.MonexCreateAccount;
        });
    }, [
        allMissions
    ]);
    var showingBanner = monexMission && [
        user/* MissionTaskStatus.NotYet */.RP.NotYet,
        user/* MissionTaskStatus.InProgress */.RP.InProgress
    ].includes(monexMission === null || monexMission === void 0 ? void 0 : (ref = monexMission.current_task) === null || ref === void 0 ? void 0 : ref.status);
    var bgUrl = (0,react.useMemo)(function() {
        return MonexBanner_randomBgUrl(monexMission === null || monexMission === void 0 ? void 0 : monexMission.coin);
    }, [
        monexMission === null || monexMission === void 0 ? void 0 : monexMission.coin
    ]);
    if (!showingBanner || !bgUrl) return fallbackElement ? fallbackElement : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((MonexBanner_module_default()).banner, className !== null && className !== void 0 ? className : ""),
        onClick: function() {
            var ref;
            (0,esm/* track */.j)("Click Top Banner", {
                banner_type: "monex_banner"
            });
            (ref = window.open(monexMission === null || monexMission === void 0 ? void 0 : monexMission.link, "_blank")) === null || ref === void 0 ? void 0 : ref.focus();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: bgUrl,
            width: "100%"
        })
    });
};
/* harmony default export */ var atoms_MonexBanner = (MonexBanner);

// EXTERNAL MODULE: ./components/atoms/TakaTradeBanner/MooMooBanner.module.scss
var TakaTradeBanner_MooMooBanner_module = __webpack_require__(8146);
var TakaTradeBanner_MooMooBanner_module_default = /*#__PURE__*/__webpack_require__.n(TakaTradeBanner_MooMooBanner_module);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/atoms/TakaTradeBanner/index.tsx





var TakaTradeBanner_randomBgUrl = function() {
    return "/images/banners/takatrade-opening-0925.jpg";
};
var TakaTradeBanner = function(param) {
    var fallbackElement = param.fallbackElement, className = param.className;
    var bgUrl = TakaTradeBanner_randomBgUrl();
    var router = (0,next_router.useRouter)();
    if (!bgUrl) return fallbackElement ? fallbackElement : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((TakaTradeBanner_MooMooBanner_module_default()).banner, className !== null && className !== void 0 ? className : ""),
        onClick: function() {
            (0,esm/* track */.j)("Click Top Banner", {
                banner_type: "takatrade_banner"
            });
            void router.push("/lp/takatrade-opening");
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: bgUrl,
            width: "100%"
        })
    });
};
/* harmony default export */ var atoms_TakaTradeBanner = (TakaTradeBanner);

// EXTERNAL MODULE: ./components/atoms/EventBanner/EventBanner.module.scss
var EventBanner_module = __webpack_require__(84466);
var EventBanner_module_default = /*#__PURE__*/__webpack_require__.n(EventBanner_module);
;// CONCATENATED MODULE: ./components/atoms/EventBanner/index.tsx




var EVENT_LINK = "https://postprime.com/PostPrime?tab=posts";
var EventBanner = function(param) {
    var className = param.className;
    var bgUrl = "/images/banners/2025-07-12-event.png";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()((EventBanner_module_default()).banner, className !== null && className !== void 0 ? className : ""),
        onClick: function() {
            var ref;
            (0,esm/* track */.j)("Click Top Banner", {
                banner_type: "event_banner"
            });
            (ref = window.open(EVENT_LINK, "_blank")) === null || ref === void 0 ? void 0 : ref.focus();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: bgUrl,
            width: "100%"
        })
    });
};
/* harmony default export */ var atoms_EventBanner = (EventBanner);

;// CONCATENATED MODULE: ./components/molecules/RandomBanner/index.tsx

















var RandomBanner = function(param) {
    var fallbackElement = param.fallbackElement, className = param.className, codes = param.codes, _isSupportRandom = param.isSupportRandom, isSupportRandom = _isSupportRandom === void 0 ? true : _isSupportRandom, fallbackCodes = param.fallbackCodes;
    var allMissions = (0,timeline/* default */.ZP)(function(state) {
        return state.allMissions;
    });
    var currentUser = (0,timeline/* default */.ZP)(function(state) {
        return state.currentUser;
    });
    var isMembershipUser = (0,membership/* isMembershipAccount */.Qx)(currentUser);
    var bannerCodes = (0,react.useMemo)(function() {
        var fbCodes = (fallbackCodes || []).map(function(value) {
            return {
                value: value,
                sort: Math.random()
            };
        }).sort(function(a, b) {
            return a.sort - b.sort;
        }).map(function(param) {
            var value = param.value;
            return value;
        });
        if (!isSupportRandom) return codes.concat(fbCodes);
        return codes.map(function(value) {
            return {
                value: value,
                sort: Math.random()
            };
        }).sort(function(a, b) {
            return a.sort - b.sort;
        }).map(function(param) {
            var value = param.value;
            return value;
        }).concat(fbCodes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var showingBannerCode = (0,react.useMemo)(function() {
        var _loop = function(i) {
            var code = bannerCodes[i];
            if (Object.values(user/* MissionCode */.Vk).includes(code)) {
                var ref;
                var m = allMissions.find(function(mission) {
                    return mission.code === code;
                });
                var ableToShow = [
                    user/* MissionTaskStatus.NotYet */.RP.NotYet,
                    user/* MissionTaskStatus.InProgress */.RP.InProgress, 
                ].includes(m === null || m === void 0 ? void 0 : (ref = m.current_task) === null || ref === void 0 ? void 0 : ref.status);
                if (ableToShow) return {
                    v: m.code
                };
            }
            if (Object.values(banner/* BannerCode */.m).includes(code)) {
                if (code === banner/* BannerCode.Izanavi */.m.Izanavi && (0,membership/* isIzanaviMember */.Wj)(currentUser)) {
                    return "continue";
                }
                if (code === banner/* BannerCode.TakatradeOpening */.m.TakatradeOpening && !(0,utils_user/* getTakaTradeOpeningEvent */.UY)(currentUser)) {
                    return "continue";
                }
                if (code === banner/* BannerCode.DiscountPrimeSub */.m.DiscountPrimeSub && !(0,utils_user/* getPrimeDiscountEvent */.Fo)(currentUser)) {
                    return "continue";
                }
                if (code === banner/* BannerCode.Event */.m.Event && new Date() >= new Date("2025-07-12 23:59:00+09:00")) {
                    return "continue";
                }
                return {
                    v: code
                };
            }
        };
        for(var i = 0; i < bannerCodes.length; i++){
            var _ret = _loop(i);
            if ((0,_type_of/* default */.Z)(_ret) === "object") return _ret.v;
        }
        return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        allMissions,
        bannerCodes,
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.expand_membership_statuses,
        currentUser === null || currentUser === void 0 ? void 0 : currentUser.applicable_promotions,
        isMembershipUser, 
    ]);
    if (!currentUser) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (!allMissions || allMissions.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (!showingBannerCode && fallbackElement) return fallbackElement;
    if (showingBannerCode === banner/* BannerCode.Izanavi */.m.Izanavi) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(molecules_IzanaviBanner, {
            className: className
        });
    }
    if (showingBannerCode === banner/* BannerCode.Event */.m.Event) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_EventBanner, {
            className: className
        });
    }
    if (showingBannerCode === banner/* BannerCode.DiscountPrimeSub */.m.DiscountPrimeSub) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimeSubscriptionDiscountCampaign_DiscountCampaignBanner, {
            className: className
        });
    }
    if (showingBannerCode === banner/* BannerCode.TakatradeOpening */.m.TakatradeOpening) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_TakaTradeBanner, {
            className: className
        });
    }
    if (showingBannerCode === banner/* BannerCode.Anime */.m.Anime) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: className,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimeAlarmBanner/* default */.Z, {})
        });
    }
    if (showingBannerCode === user/* MissionCode.IGCreateAccount */.Vk.IGCreateAccount) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_IGBanner, {
            fallbackElement: fallbackElement,
            className: className
        });
    }
    if (showingBannerCode === user/* MissionCode.InvastCreateAccount */.Vk.InvastCreateAccount) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_InvastBanner, {
            fallbackElement: fallbackElement,
            className: className
        });
    }
    if (showingBannerCode === user/* MissionCode.MonexCreateAccount */.Vk.MonexCreateAccount) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_MonexBanner, {
            fallbackElement: fallbackElement,
            className: className
        });
    }
    if (showingBannerCode === user/* MissionCode.MooMooCreateAccount */.Vk.MooMooCreateAccount) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_MooMooBanner, {
            fallbackElement: fallbackElement,
            className: className
        });
    }
    if (showingBannerCode === user/* MissionCode.MooMooCreateAccount */.Vk.MooMooCreateAccount) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_MooMooBanner, {
            fallbackElement: fallbackElement,
            className: className
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var molecules_RandomBanner = (RandomBanner);


/***/ }),

/***/ 84466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"EventBanner_banner__Kq0xu"};

/***/ }),

/***/ 37438:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"IGBanner_banner__iyUrp"};

/***/ }),

/***/ 60197:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"InvastBanner_banner__SvBU4"};

/***/ }),

/***/ 59560:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"MonexBanner_banner__QzG88"};

/***/ }),

/***/ 62187:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"MooMooBanner_banner__NVMVV"};

/***/ }),

/***/ 8146:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"MooMooBanner_banner__3CT1B"};

/***/ }),

/***/ 80850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"animeAlarmsBanner":"AnimeAlarmBanner_animeAlarmsBanner__Uu3zM","lastImage":"AnimeAlarmBanner_lastImage__j_3N5","image":"AnimeAlarmBanner_image__DaNB2","content":"AnimeAlarmBanner_content__znsmK","text":"AnimeAlarmBanner_text__FqxEb","smallText":"AnimeAlarmBanner_smallText__dztUY","purple":"AnimeAlarmBanner_purple__P8osX","blue":"AnimeAlarmBanner_blue__p3pOu"};

/***/ }),

/***/ 56972:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"DiscountCampaignBanner_banner__ydgZm"};

/***/ }),

/***/ 56841:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"IzanaviBanner_banner__w10MI"};

/***/ })

}]);